module.exports = __webpack_public_path__ + "img/cloth_g2_hat_14.ebc6da81.svg";